import axios from 'axios'

const hyu = process.env.VUE_APP_HYU

const state = () => ({
    destaqueSect: {},
    financeSect: {},
    resumePage: {},
    faqs: {},

    legalSect: {},
    seo: '',
    svg: {},
    policyLink: '',
    credit: {},
    // form: {},
    cfg_msg_no_result: 'Sem resultados',
    labels: {},
});

const getters = {
    getBoLabels: state => {
        return Object.keys(state.labels)?.length ? state.labels : null
    },
};


const mutations = {
    SET_BODATA(state, data){
        state = Object.assign(state, data)
    }
};

const actions = {
    async fetchBOdata({commit}){
        const url = hyu + process.env.VUE_APP_API_BO_DATA_API
        await axios.get(url)
        .then(res => commit('SET_BODATA', res.data))
        .catch(err => console.log(err))
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
